module.exports = __webpack_public_path__ + "static/hero-bg-snow-road-90b23d440ecebf2665345c5297b527a2.png";